export class RecoverModel {  
  email: string;
  id: string;

  public constructor(email: string, id: string){
    this.email = email;
    this.id = id;
  }
}
